/**
 * Per `operator-revenue-share` capability — platform income ledger.
 * One row per cut event written alongside each successful chat-spend
 * that earns a platform share. Independent of fan ledger + operator
 * pendingBalance — this is platform's own book of "what we earned,
 * from whom, when".
 *
 * Storage: DDB `nx-revenue-ledger-{env}`
 *   PK: revenueId (uuid)
 *   GSI: operatorId-ts-index (PK operatorId, SK ts) for per-operator monthly reports
 *
 * Monthly aggregation: GSI query `operatorId = X AND ts BETWEEN month-start AND month-end`,
 * sum cutAmount → platform's income from X that month.
 */
import { z } from 'zod';
export const RevenueLedgerEntrySchema = z.object({
    /** uuid — table PK */
    revenueId: z.string().min(1).max(64),
    /** ISO timestamp at write — GSI sort key for monthly reports */
    ts: z.string().datetime(),
    /** operator the cut was taken from — GSI partition */
    operatorId: z.string().min(1).max(128),
    characterId: z.string().min(1).max(64),
    fanId: z.string().min(1).max(128),
    /** integer points/cents earned by platform (cut share) */
    cutAmount: z.number().int().min(0),
    /** bps applied at spend time — snapshot, future cutBps changes do NOT recompute */
    cutBps: z.number().int().min(0).max(10000),
    /** gross fan spend before split */
    spendAmount: z.number().int().min(1),
    /** fan-ledger entry that triggered this revenue cut (for trace) */
    sourceTxnId: z.string().min(1).max(64),
});
